import React from 'react';
export const IntroductionSection = () => {
  return <section className="w-full py-20 bg-white" data-id="element-129">
      <div className="max-w-4xl mx-auto px-4" data-id="element-130">
        <div className="flex flex-col md:flex-row items-center gap-8 mb-12" data-id="element-131">
          <div className="w-full md:w-1/3 flex justify-center" data-id="element-132">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-full overflow-hidden border-4 border-gray-200 shadow-xl" data-id="element-133">
              <img src="https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Magda" className="w-full h-full object-cover" data-id="element-134" />
            </div>
          </div>
          <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-135">
            <p className="text-2xl font-serif mb-4" data-id="element-136">
              "Nazywam się Magda, mam 46 lat, dwoje dzieci, mieszkam w Krakowie"
            </p>
            <div className="flex justify-center md:justify-start space-x-2 text-gray-500 mb-8" data-id="element-137">
              <span data-id="element-138">•</span>
              <span data-id="element-139">żona</span>
              <span data-id="element-140">•</span>
              <span data-id="element-141">matka</span>
              <span data-id="element-142">•</span>
              <span data-id="element-143">kobieta</span>
              <span data-id="element-144">•</span>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-145">
          <div className="bg-red-50 p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-146">
            <h3 className="text-xl font-bold text-red-700 mb-4 flex items-center" data-id="element-147">
              <span className="mr-2" data-id="element-148">❌</span> PRZED
            </h3>
            <p className="text-gray-700 text-lg font-bold" data-id="element-149">
              "najgorsza żona na świecie"
            </p>
            <p className="text-gray-600 mb-4 italic" data-id="element-150">
              za gruba, za stara, za nudna
            </p>
            <ul className="mt-4 space-y-2" data-id="element-151">
              <li className="flex items-start" data-id="element-152">
                <span className="text-red-500 mr-2" data-id="element-153">•</span>
                <span data-id="element-154">Ignorowana</span>
              </li>
              <li className="flex items-start" data-id="element-155">
                <span className="text-red-500 mr-2" data-id="element-156">•</span>
                <span data-id="element-157">Niedoceniana</span>
              </li>
              <li className="flex items-start" data-id="element-158">
                <span className="text-red-500 mr-2" data-id="element-159">•</span>
                <span data-id="element-160">Niewidzialna</span>
              </li>
              <li className="flex items-start" data-id="element-161">
                <span className="text-red-500 mr-2" data-id="element-162">•</span>
                <span data-id="element-163">Niekochana</span>
              </li>
            </ul>
          </div>
          <div className="bg-green-50 p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-164">
            <h3 className="text-xl font-bold text-green-700 mb-4 flex items-center" data-id="element-165">
              <span className="mr-2" data-id="element-166">✅</span> DZIŚ
            </h3>
            <p className="text-gray-700 text-lg font-bold" data-id="element-167">
              "mąż znów patrzy na mnie jak na swoją królową"
            </p>
            <p className="text-gray-600 mb-4 italic" data-id="element-168">
              piękna, wartościowa, wyjątkowa
            </p>
            <ul className="mt-4 space-y-2" data-id="element-169">
              <li className="flex items-start" data-id="element-170">
                <span className="text-green-500 mr-2" data-id="element-171">•</span>
                <span data-id="element-172">Doceniana</span>
              </li>
              <li className="flex items-start" data-id="element-173">
                <span className="text-green-500 mr-2" data-id="element-174">•</span>
                <span data-id="element-175">Kochana</span>
              </li>
              <li className="flex items-start" data-id="element-176">
                <span className="text-green-500 mr-2" data-id="element-177">•</span>
                <span data-id="element-178">Szczęśliwa</span>
              </li>
              <li className="flex items-start" data-id="element-179">
                <span className="text-green-500 mr-2" data-id="element-180">•</span>
                <span data-id="element-181">Zauważana</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-182">
          <p className="text-lg text-gray-600 italic" data-id="element-183">
            Ale jak to się stało? Czytaj dalej...
          </p>
          <div className="mt-2 animate-bounce inline-block" data-id="element-184">
            <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-185">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-186"></path>
            </svg>
          </div>
        </div>
      </div>
    </section>;
};